export const parseTextToHtml = (text: string) => {
    return text.replace("\n", "<br>");
}
